import { Derivation } from '../interfaces/Derivation';

export const useDerivationSorting = (
  cases: Derivation[],
  sortOrder: 'asc' | 'desc'
): Derivation[] => {
  return [...cases].sort((a, b) => {
    const dateA = new Date(a.dt).getTime();
    const dateB = new Date(b.dt).getTime();

    return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
  });
};
